module.exports = __webpack_public_path__ + "static/media/11.5efa9ac6.jpg";